/* eslint no-console:0 */

import 'src/css/home/home.scss'
